import Tag from "antd/es/tag";
import styled from "styled-components";

export const FormContainer = styled.div`
  ${({ theme }) => `
  padding: 0 ${theme.paddingContentHorizontal}px;
  margin: 0 auto;
`}
`;

export const SuggestionContainer = styled.div`
  ${({ theme }) => `
  margin-top: ${theme.margin}px;
  padding: ${theme.padding}px;
  background: ${theme.colorFillQuaternary};
  border-radius: ${theme.borderRadius}px;
`}
`;

export const SuggestionTag = styled(Tag)`
  ${({ theme }) => `
  cursor: pointer;
  margin: ${theme.marginXXS}px;

  &:hover {
    border-color: ${theme.colorPrimary};
    color: ${theme.colorPrimary};
  }
`}
`;